import React from 'react';
import styled from 'styled-components';
import {device, primaryColor} from 'js/config/style.js';

import MiniText from 'js/components/core/MiniText';
import ProductDisplayFooter from './ProductDisplayFooter';
import {Link} from "@reach/router";


const ProductDesc = styled.p`
  font-size: 0.9rem;
  overflow-wrap: break-word;
  word-break: break-word;
`;

const ProductImage = styled.img`
  position: absolute;
  width: 100%;
  height: 100%;
  margin: ${({ margin }) => margin || '0'};
  border-radius: 10px;
`;

const FlexedSection = styled.div`
flex: 1 1 auto;
justify-content: flex-start;
align-items: flex-start;
flex-direction: ${({ flexDirection }) => flexDirection || 'column'};
display: ${({ display }) => display || 'block'};
margin: ${({ margin }) => margin || '0'};
padding: ${({ padding }) => padding || '0'};
width: ${({ width }) => width || 'auto'};
`;

const ImageContainer = styled.div`
  position: relative;
  flex: 1 1 auto;
  margin: 0;
  height: auto;
  min-width: 137px;
  &:after {
    content: "";
    display: block;
    padding-bottom: 100%;
  }
  @media(max-width: ${device.mobile}) {
    display: none;
  }
`;

const MobileImageContainer = styled.div`
  position: relative;
  justify-self: flex-end;
  &:after {
    content: "";
    display: block;
    padding-bottom: 100%;
  }
  width: 98px;
  margin: 0;
  height: auto;
  display: none;
  @media(max-width: ${device.mobile}) {
    display: block;
  }
`

const DisplaySection = styled.div`
  margin-bottom: 0.5rem;
  max-width: 100%;
`;

const ProductTitle = styled.h5`
  margin-bottom: 0;
  font-size: 18px;
  text-overflow: ellipsis;
`;

const Spacer = styled.div`
  flex-grow: 1;
`;

const Container = styled.div`
  position: relative;
  background: ${({ color, background }) => color || background || 'white'};
  box-shadow: 4px 4px 4px rgba(0, 0, 0, 0.05);
  border-radius: 7px;
  margin: 10px 20px;
  min-width: ${({ minWidth }) => minWidth || 'auto'};
  max-width: ${({ maxWidth }) => maxWidth || '764px'};
  padding: ${({ padding }) => padding || '10px 15px'};
  display: ${({ display }) => display || 'flex'};
  flex-direction: ${({ flexDirection }) => flexDirection || 'row'};
  align-self: ${({ alignSelf }) => alignSelf || 'normal'};

  @media(max-width: ${device.mobile}) {
    padding: ${({ mobilePadding }) => mobilePadding  || '10px 15px'};
  }
`;

const onShareAction = async (sharedData, errorCallback) => {
  try {
    await navigator.share(sharedData);
  } catch(err) {
    errorCallback?.(err);
  }
};

function truncate(str) {
  return str.length > 43 ? str.substring(0, 40) + "..." : str;
}

const alias = localStorage.getItem("STORE_ALIAS_SSS");

export default({ item, sharedData, errorCallback }) => (
  <Container
    alignSelf="auto"
    color="white"
    display="flex"
    flexDirection="row"
    minWidth="237px"
    maxWidth="764px"
    padding="10px 10px 10px 10px">
    {item?.primary_image && (
      <ImageContainer margin="0px 20px 0px 0px">
        <ProductImage src={item.primary_image} alt="product image" />
      </ImageContainer>
    )}
    <FlexedSection display="flex" padding="5px 10px 5px 5px">
      <FlexedSection display="flex" flexDirection="row" width="100%">
        <FlexedSection display="flex" flexDirection="column">
          <DisplaySection>
            <MiniText primaryColor="#0016FF" ellipsis>
              <Link to={`/seller/${item?.seller?.login ? item?.seller?.login : alias}`}>
                <img
                  src="/images/icons/icon-left.svg"
                  alt="back" style={{color: primaryColor, fontSize:'0.8rem'}}
                  width="12" height="12"
                />
                &nbsp;Back </Link><br/>@{truncate(item?.seller?.login)}</MiniText>
            <MiniText primaryColor="#484848">is selling this item:</MiniText>
          </DisplaySection>
          <DisplaySection>
            <ProductTitle>{item.title}</ProductTitle>
            {item?.description && (
              <ProductDesc>
                {item.description}
              </ProductDesc>
            )}
          </DisplaySection>
        </FlexedSection>
        {item?.primary_image && (
          <MobileImageContainer>
            <ProductImage src={item.primary_image} alt="product image" />
          </MobileImageContainer>
        )}
      </FlexedSection>
      <Spacer />
      <ProductDisplayFooter
        price={item.price}
        onAction={() => onShareAction(sharedData || {
          title: item.title,
          text: 'Your friend is sharing with you a PayOnDelivery item!',
          url: item.checkout_url,
        }, errorCallback)
        }
      />
    </FlexedSection>
  </Container>
);
